import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {InventoryReportSelectionData} from "../../inventory/controls/inventory-report-selection-control.component";
import {SupplierReportSelectionData} from "../../supplier/controls/supplier-report-selection-control.component";

export class StockReplenishmentReportData extends ReportData<StockReplenishmentReportData> {
    @field reportType: string = "SIMPLE";
    @field includeStockNotRequired: boolean = false;
    @collection() groupBy: string[] = ["none"];
    @collection(InventoryReportSelectionData) inventories: InventoryReportSelectionData[];
    @collection(SupplierReportSelectionData) suppliers: SupplierReportSelectionData[];
}
